

import React, { useEffect, useState } from "react";
import {
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Typography,
} from "@mui/material";
import { UrlApi } from "../../../../services/apirest";
import PersonIcon from "@mui/icons-material/Person";
import AssignmentIcon from "@mui/icons-material/Assignment";
import HomeIcon from "@mui/icons-material/Home";
import DoDisturbAltIcon from "@mui/icons-material/DoDisturbAlt";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PropaneTankIcon from "@mui/icons-material/PropaneTank";
import BuildIcon from "@mui/icons-material/Build";
import CallIcon from "@mui/icons-material/Call";
import ModalEleccionTanque from "./ModalEleccionTanque";
import ModalInfoTanque from "./ModalInfoTanque";

const ListItemComponent = ({ icon, primary, secondary }) => {
  // Verifica si el ícono tiene un onClick
  const isClickable = icon?.props?.onClick;

  return (
    <ListItem sx={{ alignItems: "flex-start" }}>
      <ListItemAvatar>
        <Avatar
          sx={{
            bgcolor: "#4085afff",
            color: "primary.main",
            border: "3px solid white",
            width: 30,
            height: 30,
            boxShadow: 8,
            cursor: isClickable ? "pointer" : "default",
            transition: "transform 0.2s, box-shadow 0.2s",
            "&:hover": isClickable
              ? {
                transform: "scale(1.3)",
                boxShadow: 20,
                bgcolor: "#5a9cfb",
              }
              : {},
          }}
          onClick={isClickable ? icon.props.onClick : undefined}
        >
          {/* Clona el icono para mantener su estilo */}
          {React.cloneElement(icon, { sx: { ...icon.props.sx } })}
        </Avatar>
      </ListItemAvatar>

      <ListItemText
        primary={
          <Typography
            component="div"
            variant="subtitle1"
            fontWeight="bold"
            color="text.primary"
          >
            {primary}
          </Typography>
        }
        secondary={
          <Typography
            variant="body2"
            component="div"
            color="text.secondary"
            sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
          >
            {secondary}
          </Typography>
        }
      />
    </ListItem>
  );
};

const DetalleReclamo2 = (props) => {
  const { datos, reclamos, sethayTanques, haytanques, actualizar } = props;
  const [openModal, setOpenModal] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [tanque, setTanque] = useState([]);

  const obtenerTanque = () => {

    const uuidTanques = datos.uuid_tanques || null;
    const uuid = datos.uuid || null;

    fetch(`${UrlApi}/reclamos/a/detalleTanques2/${uuidTanques}/${uuid}`)
      .then((res) => res.json())
      .then((data) => {
        setTanque(data);
      })

      .catch((err) => console.error("Error obteniendo tanque:", err));
  };

  useEffect(() => {
    obtenerTanque();
  }, [openModal2]);

  useEffect(() => {
    tanque && tanque.length ?
      sethayTanques(true) : sethayTanques(false)
  }, [tanque]);

  return (
    <div>
      <List
        sx={{
          width: "100%",
          boxShadow: 3,
          border: 0.5,
          borderRadius: 5,
          borderColor: "#b5bcc0ff",
          display: "flex",
        }}
      >
        <ListItemComponent
          icon={<HomeIcon sx={{ color: "#ffffff " }} />}
          primary="Dirección de Entrega"
          secondary={`${datos.de_direccion} (${datos.nombre_direccion})`}
        />
        <ListItemComponent
          icon={<CallIcon sx={{ color: "#ffffff " }} />}
          primary="Contacto"
          secondary={`${datos.contacto || "Sin nombre de contacto"
            } - Teléfono:${datos.telefono1 ||
            datos.telefono2 ||
            datos.telefono3 ||
            datos.tel1_cli ||
            datos.tel2_cli ||
            datos.tel3_cli ||
            "Sin teléfono"
            }`}
        />
        <ListItemComponent
          icon={<PersonIcon sx={{ color: "#ffffff " }} />}
          primary="Usuario"
          secondary={datos.usuario}
        />
        {datos?.a_cargo != null && (
          <ListItemComponent
            icon={<AttachMoneyIcon sx={{ color: "#ffffff " }} />}
            primary="Responsable gastos "
            secondary={datos.valor_cargo}
          />
        )}
        {datos.id_proveedor !== null && (
          <ListItemComponent
            icon={<BuildIcon sx={{ color: "#ffffff " }} />}
            primary="Técnico"
            secondary={`${datos.razon_prov} - Teléfono: ${datos.tel_prov}`}
          />

        )}

      </List>
      <List
        sx={{
          width: "100%",
          boxShadow: 3,
          border: 0.5,
          borderRadius: 5,
          borderColor: "#b5bcc0ff",
          display: "flex",
          mt: 1
        }}
      >


        <ListItemComponent
          icon={<AssignmentIcon sx={{ color: "#ffffff " }} />}
          primary="Detalle"
          secondary={
            <Typography variant="body2">
              {datos.detalle}{" "}
              <strong>
                {datos.id_fact ? `Factibilidad N°${datos.id_fact}` : ""}
              </strong>
            </Typography>
          }
        />

        {/* MUESTRO LOS TANQUES EN INSTALACIÓN */}
        {datos.id_motivo === 19 && (
          <>
            {/* TAB 0 */}
            {props.activeTab === 0 && (
              <>
                {tanque?.length > 0 ? (
                  <ListItemComponent
                    icon={<PropaneTankIcon sx={{ color: "#ffffff" }} />}
                    primary="Tanques"
                    secondary={
                      <ul style={{ margin: 0, paddingLeft: 16 }}>
                        {tanque.map((t) => (
                          <li key={t.id_tanque}>
                            N° serie: {t.nro_serie} – capacidad: {t.capacidad}
                          </li>
                        ))}
                      </ul>
                    }
                  />
                ) : (
                  <ListItemComponent
                    icon={<PropaneTankIcon sx={{ color: "#ffffff" }} />}
                    primary="Tanque"
                    secondary={
                      <Typography
                        variant="body2"
                        sx={{
                          cursor: "pointer",
                          color: "red",
                          fontWeight: "bold",
                          textDecoration: "underline",
                        }}
                        onClick={() => setOpenModal2(true)}
                      >
                        Elegir tanque
                      </Typography>
                    }
                  />
                )}
              </>
            )}

            {/* TAB 1 */}
            {props.activeTab === 1 && tanque?.length > 0 && (
              <ListItemComponent
                icon={<PropaneTankIcon sx={{ color: "#ffffff" }} />}
                primary="Tanques"
                secondary={
                  <ul style={{ margin: 0, paddingLeft: 16 }}>
                    {tanque.map((t) => (
                      <li key={t.id_tanque}>
                        N° serie: {t.nro_serie} – capacidad: {t.capacidad}
                      </li>
                    ))}
                  </ul>
                }
              />
            )}
          </>
        )}

        {/*MUESTRO LOS TANQUES EN DESCONEXIÓN */}
        {datos.id_motivo === 20 && (
          <>
            {
              tanque && tanque.length > 0 && (
                <ListItemComponent
                  icon={<PropaneTankIcon sx={{ color: "#ffffff" }} />}
                  primary="Tanques a desconectar"
                  secondary={
                    <ul style={{ margin: 0, paddingLeft: 16 }}>
                      {tanque.map((t) => (
                        <li key={t.id_tanque}>
                          N° serie: {t.nro_serie} – capacidad: {t.capacidad}
                        </li>
                      ))}
                    </ul>
                  }
                />
              )
            }

          </>
        )}


        {datos.id_motivo === 41 && props.activeTab === 0 && tanque?.length > 0 && (
          <ListItemComponent
            icon={<PropaneTankIcon sx={{ color: "#ffffff" }} />}
            primary="Tanques"
            secondary={
              <ul style={{ margin: 0, paddingLeft: 16 }}>
                {tanque.map((t) => (
                  <li key={t.id_tanque}>
                    N° serie: {t.nro_serie} – capacidad: {t.capacidad}
                    (
                    {t.instalacion === 1 ?
                      "instalación" :
                      "desconexión"})
                  </li>
                ))}
              </ul>
            }
          />
        )}

        {datos.id_motivo === 41 && props.activeTab === 1 && tanque?.length > 0 && (
          <ListItemComponent
            icon={<PropaneTankIcon sx={{ color: "#ffffff" }} />}
            primary="Tanques"
            secondary={
              <ul style={{ margin: 0, paddingLeft: 16 }}>
                {tanque.map((t) => (
                  <li key={t.id_tanque}>
                    N° serie: {t.nro_serie} – capacidad: {t.capacidad}
                    (
                    {t.instalacion === 1 ?
                      "instalación" :
                      "desconexión"})
                  </li>
                ))}
              </ul>
            }
          />
        )}

        {datos.id_motivo === 41 && props.activeTab === 2 && tanque?.length > 0 && (
          <>
            {/* MUESTRO LOS TANQUES QUE VOY A DESCONECTAR */}
            {tanque && tanque.filter((t) => t.instalacion === 0).length > 0 && (
              <ListItemComponent
                icon={<PropaneTankIcon sx={{ color: "#ffffff" }} />}
                primary="Tanques a desconectar"
                secondary={
                  <ul style={{ margin: 0, paddingLeft: 16 }}>
                    {tanque
                      .filter((t) => t.instalacion === 0)
                      .map((t) => (
                        <li key={t.id_tanque}>
                          N° serie: {t.nro_serie} – capacidad: {t.capacidad}
                        </li>
                      ))}
                  </ul>
                }
              />
            )}
            {/* BOTON PARA ELEGIR NUEVOS TANQUES */}
            {tanque.filter((t) => t.instalacion === 1).length === 0 && (
              <ListItemComponent
                icon={<PropaneTankIcon sx={{ color: "#ffffff" }} />}
                primary="Seleccionar tanques nuevos"
                secondary={
                  <Typography
                    variant="body2"
                    sx={{
                      cursor: "pointer",
                      color: "#1976d2",
                      fontWeight: "bold",
                      textDecoration: "underline",
                    }}
                    onClick={() => setOpenModal2(true)}
                  >
                    Agregar tanques nuevos
                  </Typography>
                }
              />
            )}
            {tanque && tanque.filter((t) => t.instalacion === 1).length > 0 && (
              <ListItemComponent
                icon={<PropaneTankIcon sx={{ color: "#ffffff" }} />}
                primary="Nuevos tanques instalados"
                secondary={
                  <ul style={{ margin: 0, paddingLeft: 16 }}>
                    {tanque
                      .filter((t) => t.instalacion === 1)
                      .map((t) => (
                        <li key={t.id_tanque}>
                          N° serie: {t.nro_serie} – capacidad: {t.capacidad}
                        </li>
                      ))}
                  </ul>
                }
              />
            )}
          </>
        )}

      </List>

      {datos.estado === 223 ?
        <List
          sx={{
            width: "1300px",
            boxShadow: 3,
            border: 0.5,
            borderRadius: 5,
            borderColor: "#b5bcc0ff",
            display: "flex",
            marginTop: 2,
          }}
        >
          <ListItemComponent
            icon={
              <DoDisturbAltIcon
                sx={{
                  color: "#ffffff", // color
                  stroke: "#ff4000", // borde
                  strokeWidth: 0.8, // grosor del borde
                }}
              />
            }
            primary="Motivo de cancelación"
            secondary={datos.detalles_cancelacion}
          />

        </List>
        : null}


      {
        openModal ? (
          <ModalInfoTanque
            open={openModal}
            datos={datos}
            handleClose={() => setOpenModal(false)}
          />
        ) : null
      }

      {
        openModal2 ? (
          <ModalEleccionTanque
            open={openModal2}
            datos={datos}
            tanquesAsociados={tanque}
            handleClose={() => {
              obtenerTanque()
              setOpenModal2(false)
            }}
            reclamos={reclamos}
            actualizar={obtenerTanque}
          />
        ) : null
      }
    </div>
  );
};

export default DetalleReclamo2;